import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

/**
 * wallet
 */


export interface AddressAutoComplete {
    predictions: Prediction[],
}

export interface Prediction {
    description: string;
    matched_substrings: MatchedSubstring[];
    place_id: string;
    latlng?: string; // thêm format thôi
    minute: number;
    extra_price: number;
    reference: string;
    structured_formatting: StructuredFormatting;
    terms: Term[];
    types: string[];
    distance_meters?: number;
}

export interface MatchedSubstring {
    length: number;
    offset: number;
}

export interface StructuredFormatting {
    main_text: string;
    main_text_matched_substrings: MatchedSubstring[];
    secondary_text: string;
}

export interface Term {
    offset: number;
    value: string;
}


export function useGetGoogleMapsSuggest(address: string) {
    return useQuery({
        queryKey: ["google_maps/google_maps_suggestions/fetch_entity_list", address],
        queryFn: () => axios.get<AddressAutoComplete>(`google_maps/google_maps_suggestions/?address=${encodeURIComponent(address)}`).then(response => response.data),
        retry: 1,
        enabled: !!address,
    });
}

export function useMutateGetGoogleMapsSuggest() {
    return useMutation({
        mutationKey: ["google_maps/google_maps_suggestions/fetch_entity_list"],
        mutationFn: ({ address, latlong }: { address: string; latlong: string }) => axios.get<AddressAutoComplete>(`google_maps/google_maps_suggestions/?address=${encodeURIComponent(address)}&latlong=${encodeURIComponent(latlong)}`).then(response => response.data),
        retry: 1,
    });
}

export function useGetMapsPlaceDetail() {
    return useMutation({
        mutationKey: ["google_maps/google_maps_get_placedetail/fetch_entity_list"],
        mutationFn: ({ place_id, journey_id = '' }: { place_id: string, journey_id?: string }) => axios.get<{ place_id: string, lat: number, lng: number, commune: string, province: string, pickup_support: number, extra_price: number, pickup_time: number, note: string, position_name: string }>(`google_maps/google_maps_get_placedetail/${place_id}?journey_id=${journey_id}`).then(response => response.data),
        retry: 1,
    });
}
